import { extractData } from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import { DocumentPageSchema } from "./schemas";
import type { DocumentPageType } from "./types";

export const mapDtoToDocumentPage = (dto: unknown): DocumentPageType[] => {
  const parsed = safeParseWithFallback(
    DocumentPageSchema,
    dto,
    "mapDtoToDocumentPage",
  );

  return extractData(parsed, dto, []);
};
